module.exports = __webpack_public_path__ + "static/media/ary-young.15387216.jpeg";